// extracted by mini-css-extract-plugin
export default {"inputArea":"customInput_inputArea__Iy5c2"};